import React from "react";
import {Typography} from "@mui/material";
import {Blue3, White} from "../../theme/styles";

type Props = {
    /** Title shown in the blue bar. */
    title: string;
    /** Optional right-aligned actions (buttons, menus, …). */
    children?: React.ReactNode;
};

/**
 * Standard page header — the 52px blue title bar used across the app.
 * Mirrors the inline blue bar t2 pages render (e.g. DashboardMonitoring.tsx),
 * factored into one reusable component.
 */
export default function PageHeader({title, children}: Props) {
    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: 52,
            minHeight: 52,
            backgroundColor: Blue3,
        }}>
            <div style={{paddingLeft: "20px"}}>
                <Typography style={{fontSize: 24, fontWeight: 400, color: White}}>{title}</Typography>
            </div>
            {children ? (
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: "15px"}}>
                    {children}
                </div>
            ) : null}
        </div>
    );
}
